import { extractPersonFromJsonLd } from './index';
export var extractPersonOwnedBy = function extractPersonOwnedBy(jsonLd) {
  var ownedBy = jsonLd['atlassian:ownedBy'];
  if (ownedBy) {
    if (Array.isArray(ownedBy)) {
      return ownedBy.map(extractPersonFromJsonLd).filter(function (item) {
        return !!item;
      });
    } else {
      var item = extractPersonFromJsonLd(ownedBy);
      if (item) {
        return [item];
      }
    }
  }
};